// @vendors
import { useTranslation } from 'react-i18next';
//import { StarIcon } from "@heroicons/react/24/solid";
//import ItemOpinion from './ItemOpinion';

const OpinionView = () => {
    const { t } = useTranslation();

    /* const ratingValue = (index: number, value: number) => {
        return (
            <div className='w-full flex item-center justify-center gap-[15px] py-[10px]'>
                <p className='flex text-[#000000]/60 dark:text-white/60 text-[15px]'>{index}</p>
                <div className='w-full'>
                    <progress
                        id="file"
                        max="100"
                        value={value}
                        className="w-full h-2 appearance-none [&::-webkit-progress-bar]:rounded-[10px] [&::-webkit-progress-bar]:bg-[#000000]/10 dark:[&::-webkit-progress-bar]:bg-white/20 [&::-webkit-progress-value]:rounded-[10px] [&::-webkit-progress-value]:bg-[#FFB400] [&::-moz-progress-bar]:rounded-[10px] [&::-moz-progress-bar]:bg-[#FFB400]"
                    ></progress>
                </div>
            </div>
        )
    } */

    return (
        <>
            <div className='w-full h-[50vh] flex items-center justify-center'>
                <p className='flex text-[30px] text-gray-400 dark:text-white text-center'>
                    {t("userProfile.comingSoon")}
                </p>
            </div>

            {/* <div className='w-full flex flex-col lg:flex-row gap-[30px] h-[80vh]'>
            <div className="w-full flex flex-col gap-[20px]">
                <h3 className='w-full flex item-center justify-center text-[#444A6D] dark:text-white text-[15px] font-medium '>
                    {t("requestsAndProposals.details.ratingAnOpinion")}(120)
                </h3>
                <h6 className='w-full flex item-center justify-center text-[#000000]/70 dark:text-white/70 text-[14px] font-normal'>
                    {t("requestsAndProposals.details.summary")}
                </h6>

                <section className="w-full flex gap-[20px]">
                    <div className="w-full">
                        {ratingValue(5, 100)}
                        {ratingValue(4, 80)}
                        {ratingValue(3, 60)}
                        {ratingValue(2, 40)}
                        {ratingValue(1, 20)}
                    </div>

                    <div className='w-[100px] flex flex-col items-center gap-[10px] '>
                        <div className='flex items-center gap-[5px] mt-[20px]'>
                            <p className='text[#000000] text-[25px]'>4.5</p>
                            <StarIcon className='w-[20px] h-auto text-[#FFB400]' />
                        </div>
                        <p className='w-full flex item-center justify-center text-[#6A6A6A]/70 dark:text-white/70 text-[13px] font-normal'>
                            273 {t("requestsAndProposals.details.reviews")}
                        </p>
                        <p className='text[#000000] text-[25px] mt-[20px]'>
                            88%
                        </p>
                        <p className='w-full flex item-center justify-center text-[#6A6A6A]/70 dark:text-white/70 text-[13px] font-normal'>
                            {t("requestsAndProposals.details.recommended")}
                        </p>
                    </div>
                </section>

                <p className='w-full flex item-center justify-center text-[#6A6A6A] dark:text-white/80 text-[14px] font-normal'>
                    {t("requestsAndProposals.details.textRating")}
                </p>
            </div>

            <div className="w-full flex flex-col gap-[20px]">
                <ItemOpinion />
                <ItemOpinion />
                <ItemOpinion />
                <ItemOpinion />
            </div>
        </div> */}
        </>
    )
}

export default OpinionView